const rbi = [];
const ribSetSize = (img) => {
  if ( img.offsetWidth / img.dataset.ratio < img.offsetHeight ) {
    img.setAttribute('sizes', `${Math.ceil(img.offsetHeight * img.dataset.ratio)}px`);
  } else {
    img.setAttribute('sizes', `${Math.ceil(img.offsetWidth)}px`);
  }
}
const debounce = (fn, wait) => {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
window.debounce = debounce; // Expose globally

window.KEYCODES = { TAB: 9, ESC: 27, DOWN: 40, RIGHT: 39, UP: 38, LEFT: 37, RETURN: 13 };
window.addEventListener('resize', debounce(()=>{ for ( let img of rbi ) { ribSetSize(img); } }, 250));

/* --- NH HAPTICS & MICRO-INTERACTIONS --- */
window.nhHaptics = (type = 'light') => {
  if (!navigator.vibrate) return;
  
  const patterns = {
    light: 10,       // Click semplice
    medium: 30,      // Selezione
    heavy: 50,       // Errore/Warning
    success: [30, 50, 30], // Successo operazione
    error: [50, 100, 50]   // Errore critico
  };
  
  try {
    navigator.vibrate(patterns[type] || 10);
  } catch(e) { /* Ignore privacy block */ }
};

// Effetto Ripple sui bottoni
document.addEventListener('click', (e) => {
  const btn = e.target.closest('.button, .btn, .shopify-payment-button__button, .js-add-to-cart');
  if (btn) {
    // Haptic feedback immediato al click
    window.nhHaptics('light');

    // Ripple Effect
    const rect = btn.getBoundingClientRect();
    const circle = document.createElement('span');
    const diameter = Math.max(rect.width, rect.height);
    const radius = diameter / 2;

    circle.style.width = circle.style.height = `${diameter}px`;
    circle.style.left = `${e.clientX - rect.left - radius}px`;
    circle.style.top = `${e.clientY - rect.top - radius}px`;
    circle.classList.add('nh-ripple-effect');

    // Assicura che il bottone abbia position relative/absolute
    const style = window.getComputedStyle(btn);
    if (style.position === 'static') btn.style.position = 'relative';
    if (style.overflow !== 'hidden') btn.style.overflow = 'hidden';

    const existingRipple = btn.querySelector('.nh-ripple-effect');
    if (existingRipple) existingRipple.remove();

    btn.appendChild(circle);
    setTimeout(() => circle.remove(), 600);
  }
});

/* --- NH HOLOGRAPHIC TOAST SYSTEM --- */
window.nhToast = (message, type = 'success', duration = 4000) => {
  let container = document.querySelector('.nh-toast-container');
  if (!container) {
    container = document.createElement('div');
    container.className = 'nh-toast-container';
    document.body.appendChild(container);
  }

  const toast = document.createElement('div');
  toast.className = `nh-toast ${type}`;
  
  const icon = type === 'error' ? '[!]' : '[?]';
  
  toast.innerHTML = `
    <span class='nh-toast-icon'>${icon}</span>
    <div class='nh-toast-content'>${message}</div>
    <div class='nh-toast-progress'></div>
  `;

  container.appendChild(toast);
  
  // Haptic feedback based on type
  if (window.nhHaptics) window.nhHaptics(type === 'error' ? 'error' : 'success');

  const removeToast = () => {
    toast.classList.add('exit');
    setTimeout(() => toast.remove(), 400);
  };

  const timeout = setTimeout(removeToast, duration);

  toast.onclick = () => {
    clearTimeout(timeout);
    removeToast();
  };
};
